import type { ParsedUrlQuery } from "node:querystring";
import { SearchQueryParams } from "src/components/pages/search/search.types";
import { LOCALE_PARAMETERS } from "src/constants/locale";

const isViewParam = (key: string) => key.toLowerCase() === SearchQueryParams.View.toLowerCase();

const isFilterParam = (key: string) => !LOCALE_PARAMETERS.includes(key) && !isViewParam(key);

export const hasFilterParams = (query: ParsedUrlQuery) => Object.keys(query).some(isFilterParam);

export const isOnlySearchTermPresent = (query: ParsedUrlQuery) => {
    const keys = Object.keys(query).filter(isFilterParam);
    return keys.length === 1 && keys[0] === SearchQueryParams.SearchTerm;
};
